import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import ModalActions from 'Modules/Modals/actions';
import { EnumTheme, ModalType, EnumButtonSize, WLabel } from 'constants/enums';
import ThemeButton from 'Components/ThemedButton';
import Text from 'Components/Typography/Text';
import { colors } from 'constants/colors';
import { FontSize, FontWeight } from 'theme';
import { selectByWL } from 'utils/wLabel';

export const AUTH_BTN_TEST_ID = 'AUTH_BTN_TEST_ID';
const ButtonText = styled(Text).attrs(
  selectByWL({
    [WLabel.Default]: {
      size: FontSize.xxs,
    },
    [WLabel.Globus]: {
      fontWeight: FontWeight.semiBold,
      size: FontSize.s,
    },
  })
)`
  position: relative;
  padding: 0 3px;
  z-index: 1;

  &::after {
    content: '';
    display: none;
    position: absolute;
    border-radius: 2.5px;
    height: 5px;
    width: 100%;
    left: 0;
    bottom: 3px;
    background-color: ${colors.sweetCorn};
    z-index: -1;
  }
`;

const Button = styled(ThemeButton).attrs({
  use: EnumTheme.roundWhite,
  size: EnumButtonSize.small,
  testId: AUTH_BTN_TEST_ID,
})`
  &:hover {
    div::after {
      display: block;
    }
  }
`;

const TempUserButton: React.FC = () => {
  const dispatch = useDispatch();
  const openAuthModal = () => dispatch(ModalActions.openModal(ModalType.Auth));

  return (
    <Button onClick={openAuthModal}>
      <ButtonText>Войти</ButtonText>
    </Button>
  );
};

export default TempUserButton;
